export default "__VITE_ASSET__e634657b__"